export enum IdentityDocTypeEnum {
  Passport = 1,
  NationalId = 2,
  DrivingLicence = 3,
  ResidenceId = 4,
}
